import { Directive, Input } from '@angular/core';
import { NavNode } from '../navigator-node.component';

/**
 * Shared base for all navigator leaf components.
 * Provides `@Input() node: NavNode`.
 */
@Directive()
export abstract class NavBaseComponent {
    @Input() node!: NavNode;
}
